import { z } from 'zod';

// Build-time settings (Vite inlines VITE_* values). Fails loudly if the API URL is missing.
const schema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_APP_VERSION: z.string().default('dev'),
  VITE_SENTRY_DSN: z
    .string()
    .url()
    .optional()
    .or(z.literal('').transform(() => undefined)),
  VITE_RECAPTCHA_SITE_KEY: z
    .string()
    .min(10)
    .optional()
    .or(z.literal('').transform(() => undefined)),
  /** Browser key for the Maps JavaScript API, limited to our domains in Google Cloud; without it maps fall back
   * to a plain embed and the location picker is off */
  VITE_GOOGLE_MAPS_API_KEY: z
    .string()
    .min(10)
    .optional()
    .or(z.literal('').transform(() => undefined)),
  /** Shown in the sidebar's help card */
  VITE_SUPPORT_EMAIL: z.string().email().default('support@hemmafixa.se'),
});

const parsed = schema.parse(import.meta.env);

export const env = {
  apiUrl: parsed.VITE_API_URL.replace(/\/$/, ''),
  appVersion: parsed.VITE_APP_VERSION,
  sentryDsn: parsed.VITE_SENTRY_DSN,
  recaptchaSiteKey: parsed.VITE_RECAPTCHA_SITE_KEY,
  googleMapsApiKey: parsed.VITE_GOOGLE_MAPS_API_KEY,
  supportEmail: parsed.VITE_SUPPORT_EMAIL,
};
